<template>
    <div class="login">
        <div class="login_form">
            <div class="item_form">
                <div class="form_title">手机号</div>
                <div class="form_filed">
                    <van-field v-model="phone" placeholder="请输入您的手机号" :border="false" type="tel" />
                    <div class="find_code" @click="getCode">获取</div>
                </div>
            </div>
            <div class="item_form">
                <div class="form_title">短信验证码</div>
                <div class="form_filed">
                    <van-field v-model="password" placeholder="请输入您收到的验证码" type="password" :border="false" />
                </div>
            </div>
            <van-button block :loading="btnLoading" :disabled="submitLoading" class="login_action" @click="login">修改手机号</van-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: 'login',
    data() {
        return {
            phone: '',
            password: '',
			submitLoading: false, // 提交loading
			btnLoading: false, // 加载loading
			publicPath: process.env.BASE_URL,
        };
    },
    created: function () {
		//根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
        }
    },
    methods: {
        // 登录
        login() {
            var that = this;
            that.submitLoading = true;
            if (!that.phone) {
                that.$toast('请输入手机号');
                that.submitLoading = false;
                return
			}else if(!(/^1[3456789]\d{9}$/.test(that.phone))) {
				that.$toast('请输入合法的手机号');
				that.submitLoading = false;
				return
			}
            if (!that.password) {
                that.$toast('请输入验证码');
                that.submitLoading = false;
                return
            }
            var param = {
                'phone': that.phone,
                'code': that.password,
                'token': this.token
			}
			that.btnLoading = true
            that.$api.my.phone(param).then(res => {
                if (res.code === 200) {
                    console.log(res)
                    that.$store.commit(LOGIN, {
                        // name: res.result.user.username,
                        token:  res.result.user.token,
                        // uuid: res.result.user.uuid,
                    });
                    // // that.$router.back();
                    // that.$notify({
                    //     type: 'success',
                    //     message: '登录成功'
					// });
					that.$toast('登录成功');
					that.btnLoading = false
                    // if (res.result.role == 1) {
                    //     // 管理员登录
                    //     that.$router.push('/m/manage/index');
                    // } else if (res.result.role == 2) {
                    //     // 代销
                    //     that.$router.push('/m/index');
					// }
					if(this.$route.query.redirect){
						that.$router.push({
							path: this.$route.query.redirect
						});
					}else{
						that.$router.push('/');
					}
                    
                } else {
					that.btnLoading = false
                    that.submitLoading = false;
                }
			})
		},
		// 获取yanzhengm 
		getCode(){
			this.$toast('正在开发中...')
		},
		// 微信登录
		loginWechat(){
			this.$toast('正在开发中...')
		}
        
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
</style>
